import { render, staticRenderFns } from "./Opening.vue?vue&type=template&id=07b8786e&scoped=true"
import script from "./Opening.vue?vue&type=script&lang=js"
export * from "./Opening.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b8786e",
  null
  
)

export default component.exports